// extracted by mini-css-extract-plugin
export default {"resourceColHeader":"styles_resourceColHeader__6W7Mm","cta":"styles_cta__7A9rj","cellWrap":"styles_cellWrap__1a1Ju","editIcon":"styles_editIcon__5wuGo"};